import { MySpaceType } from "./mySpaceTypes";


export const mySpaceReducer = {
  resetMySpaceSuccess: (state: MySpaceType) => {
    state.success = null;
  },
  resetMySpaceError: (state: MySpaceType) => {
    state.error = null;
  },
  resetMySpaceMessage: (state: MySpaceType) => {
    state.message = null;
  },
  resetMySpaceStatusCode: (state: MySpaceType) => {
    state.statusCode = null;
  },
  resetMySpaceWorkAnniversaryList: (state: MySpaceType) => {
    state.mySpaceWorkAnniversaryList = [];
  },
  resetUpcomingBirthdayList: (state: MySpaceType) => {
    state.upcomingBirthdayList = [];
  },
  resetPeopleOnLeaveList: (state: MySpaceType) => {
    state.peopleOnLeaveData = [];
  },
  resetAttendanceAverage: (state: MySpaceType) => {
    state.attendanceAverage = 0;
  },
  resetCheckInScheduleList: (state: MySpaceType) => {
    state.checkInScheduleList = [];
    state.checkInScheduleTotalCount = 0;
  },
  resetCheckInScheduleManagerViewList: (state: MySpaceType) => {
    state.checkInScheduleManagerViewList = [];
  },
  resetManagersAvailableCheckInScheduleSlots: (state: MySpaceType) => {
    state.managersAvailableCheckInScheduleSlots = [];
  },
  resetSingleCheckInScheduleDetails: (state: MySpaceType) => {
    state.singleCheckInScheduleDetails = {};
  },
  resetPerformanceEvaluationList: (state: MySpaceType) => {
    state.performanceEvaluationList = [];
  },
  resetPerformanceEvaluationTotalCount: (state: MySpaceType) => {
    state.performanceEvaluationTotalCount = 0;
  },
  resetSinglePeDetailsList: (state: MySpaceType) => {
    state.singlePeDetailsList = [];
  },
  resetAverageJobRatingList :(state:MySpaceType)=>{
    state.averageJobRatingList=[];
  },
  resetAverageJobRatingCount :(state:MySpaceType)=>{
    state.averageJobRatingCount=0;
  },
  resetViewMyTeamMembersData: (state: MySpaceType) => {
    state.viewTeamMembersData=[]
  },
  resetViewMyTeamMembersCount: (state: MySpaceType) => {
    state.viewTeamMembersCount=0;
  }

};
